export const routes = [
  {
    path: "/municipioTemasHabilitados",
    component: () => import(/* webpackChunkName: "ur" */ "./components/List"),
    name: "municipioTemas.list",
    meta: {
      requiresAuth: true,
    },
  },
];
